




























































































































import { Component, Vue } from 'vue-property-decorator';
import { IRules, sValidation } from '../UI/Form/ValidationModule';
import { validateMin, validateRequired, validateType } from '../UI/Form/Validations';
import PhoneInput from '@/components/PhoneInput.vue';
import { GQL_allCountries_allCountries } from '@/queries/__generated__/allCountries';
import Locale from '@/utils/locale';
import { fetchPostCityForZip } from '@/utils/postal-code';

const validatePassword: sValidation = data => {
  if (!data.formElements.password) return true;

  return data.dataValue === data.formElements.password.dataValue;
};

@Component({
  components: {
    PhoneInput,
  },
})
export default class RegisterForm extends Vue {
  private allCountries: GQL_allCountries_allCountries[] | null = null;

  private loading = false;
  private errorMessage = null as string | null;
  private successMessage = null as string | null;

  private mounted() {
    this.fetchCountries();
  }

  private registerCredentials = {
    firstName: null as string | null,
    lastName: null as string | null,
    cellphoneCountryCode: 'NO',
    phoneCode: null as string | null,
    cellphone: '',
    address: null as string | null,
    zip: null as string | null,
    city: null as string | null,
    countryCode: 'NO',
    email: null as string | null,
    password: null as string | null,
    confirmPassword: null as string | null,
  };

  private serverHost: string | undefined = process.env.VUE_APP_API_HTTP;

  private async register() {
    const body = {
      new_user: {
        first_name: this.registerCredentials.firstName,
        last_name: this.registerCredentials.lastName,
        phone_code: this.registerCredentials.phoneCode,
        cellphone_country_code: this.registerCredentials.countryCode,
        cellphone: this.registerCredentials.cellphone,
        login: this.registerCredentials.email?.toLowerCase(),
        password: this.registerCredentials.password,
        password_confirmation: this.registerCredentials.confirmPassword,
      },
      new_unit: {
        address: this.registerCredentials.address,
        zip: this.registerCredentials.zip,
        city: this.registerCredentials.city,
        country_code: this.registerCredentials.countryCode,
      },
      locale: Locale.get(),
    };
    this.loading = true;

    try {
      const response = await fetch(`${this.serverHost}/accounts/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      this.loading = false;

      if (response.status === 200) {
        this.successMessage = this.$t('Account.confirmRegistrationMailSent') as string;
      } else {
        const payload = await response.json();
        if (payload.errors) {
          this.errorMessage = payload.errors.join(', ');
        } else {
          this.errorMessage = this.$t('Error.somethingWentWrong') as string;
        }
      }
    } catch (error) {
      this.loading = false;
      this.errorMessage = this.$t('Error.somethingWentWrong') as string;
    }

  }

  private async fillCity() {
    const city = await fetchPostCityForZip(this.serverHost, this.registerCredentials);

    if(city) this.registerCredentials.city = city;
  }

  private async fetchCountries() {
    try {
      const response = await fetch(`${this.serverHost}/countries`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.status === 200) {
        const countries: {code: string; name: string; phone_code: string}[] = await response.json();
        this.allCountries = countries.map(country => {
          return {
            code: country.code,
            name: country.name,
            phoneCode: country.phone_code,
          };
        }) as GQL_allCountries_allCountries[];
      } else {
        this.errorMessage = this.$t('Error.somethingWentWrong') as string;
      }
    } catch (error) {
      this.errorMessage = this.$t('Error.somethingWentWrong') as string;
    }

  }

  private validForm = true;

  private rules: IRules = {
    firstName: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.firstName') }),
      },
    ],
    lastName: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.lastName') }),
      },
    ],
    cellphone: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.cellphone') }),
      },
    ],
    address: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.address') }),
      },
    ],
    zip: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.zip') }),
      },
    ],
    city: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.city') }),
      },
    ],
    countryCode: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.country') }),
      },
    ],
    email: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.email') }),
      },
      {
        validation: validateType('email'),
        message: i18n => i18n.t('Error.email'),
      },
    ],
    password: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.password') }),
      },
      {
        validation: validateMin(6),
        message: i18n => i18n.t('Error.minLength', { length: 6 }),
      },
    ],
    confirmPassword: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.confirmPassword') }),
      },
      {
        validation: validatePassword,
        message: i18n => i18n.t('Account.passwordNotSame'),
      },
    ],
  };
}
